export const zhCN = {
  shell: {
    language: {
      label: '语言',
      english: 'English',
      simplifiedChinese: '简体中文',
    },
    theme: {
      switchTo: '切换到{{mode}}模式',
      light: '浅色',
      dark: '深色',
    },
    nav: {
      openNavigation: '打开导航',
      closeNavigation: '关闭导航',
      mobileNavigation: '移动导航',
      home: '首页',
      tools: '工具',
      apps: '应用',
      benchmarks: '基准测试',
      blog: '博客',
      devDocs: '开发文档',
      download: '下载',
      downloadDesktopApps: '下载桌面应用',
      signUp: '注册',
      selfHost: '在 GitHub 上查看自托管运行时',
      soon: '即将推出',
      browseAllTools: '浏览全部 {{count}} 个工具',
      browseDownloads: '全部下载',
    },
    apps: {
      macos: {
        title: 'Mac 桌面版',
        body: 'Apple 芯片 Mac，macOS 13 或更高版本。候选发布。',
      },
      windows: {
        title: 'Windows 桌面版',
        body: 'Windows 10 或更高版本，x64。测试版。',
      },
      chrome: {
        title: 'Chrome 扩展',
        body: '为标签页中的 PDF 提供 Markdown、表格和无障碍检查。',
      },
    },
    categoryBody: {
      accessibility: '检查 PDF/UA、Matterhorn 和 PDF 标签。',
      organize: '合并、拆分和重新排序页面。',
      edit: '遮盖、签名、加水印和旋转。',
      convertTo: '将 Excel、Word 和图片转为 PDF。',
      convertFrom: '将 PDF 转为 Markdown、JSON、Excel 和图片。',
      optimize: '压缩、OCR、扁平化和比较 PDF。',
    },
    footer: {
      description:
        '用 AI 智能体把 PDF 转成可用的文档智能。提供 TypeScript SDK、开源 CLI 和自托管运行时。',
      products: '产品',
      tools: '工具',
      resources: '资源',
      parse: '解析',
      extract: '提取',
      pdfAgents: 'PDF 智能体',
      pdfMcp: 'PDF MCP',
      pdfCli: 'PDF CLI',
      selfHost: '自托管',
      workflows: '工作流',
      audit: '无障碍审计',
      pdfToFigma: 'PDF 转 Figma',
      chromeExtension: 'Chrome 扩展',
      mergePdf: '合并 PDF',
      splitPdf: '拆分 PDF',
      compressPdf: '压缩 PDF',
      pdfToWord: 'PDF 转 Word',
      pdfToExcel: 'PDF 转 Excel',
      pdfToHtml: 'PDF 转 HTML',
      pdfToMarkdown: 'PDF 转 Markdown',
      allTools: '全部工具',
      benchmark: '基准测试',
      github: 'GitHub',
      discord: 'Discord',
      industries: '行业方案',
      privacy: '隐私',
      terms: '条款',
    },
  },
  home: {
    meta: {
      title: 'okraPDF：用 AI 智能体把 PDF 转成文档智能',
      description:
        '用 okraPDF 解析、引用、提取、托管和审核 PDF 工作流。支持 TypeScript SDK、CLI、API、MCP 与自托管。',
    },
    hero: {
      badge: '智能体 PDF 文档智能',
      titleBefore: '用 AI 智能体把 PDF 转成',
      titleAccent: '文档智能',
      body: '从 Claude、Codex、Cursor、MCP、CLI 和 API 工作流自动规划、解析、引用并流转 PDF。okraPDF 为智能体提供带页码证据的 TypeScript 文档图谱、结构化提取和生产级交接。',
      startFree: '免费开始',
      discordSupport: 'Discord 支持',
      agenticLink: '我需要智能体 PDF 能力',
      normalToolsLink: '我只需要常用 PDF 工具',
      selfHostLink: '我需要自托管',
      runsInside: '可用于',
      videoLabel:
        'okraPDF 文档工作流演示：示例发票从页面预览进入模板提取，再导出为 JSON、CSV 或 Webhook。',
    },
    audience: {
      kicker: 'okraPDF 适合谁？',
      heading: '把 PDF 变成智能体可直接使用的工作成果。',
      cards: {
        agentic: {
          title: '智能体团队',
          body: '向 Claude、Codex、Cursor 或自有 Worker 下达任务。okraPDF 提供带引用的 PDF 上下文、类型化字段和可执行操作。',
        },
        developers: {
          title: '开发者',
          body: '用 TypeScript SDK、REST API、CLI 和 MCP 资源目录构建原生 PDF 产品。一份文档图谱服务所有入口。',
        },
        automation: {
          title: '自动化团队',
          body: '把发票、对账单、表单和审核材料送入 Webhook、n8n、Make、Zapier、Sheets 或人工审批队列。',
        },
      },
    },
    workflow: {
      kicker: '智能体工作流',
      heading: '端到端完成 PDF 流程：解析、提问、提取、审核、发布。',
      body: 'okraPDF 是智能体背后的文档智能层。每份 PDF 都有持久图谱、证据链接、类型化契约和工作流操作，并通过同一套 API、CLI 与 MCP 使用。',
      features: {
        graph: {
          label: '文档图谱',
          detail:
            '只需上传一次，智能体即可从同一文档 ID 读取页面、表格、图片、产物和历史运行结果。',
        },
        proof: {
          label: '页面证据',
          detail: '每条引用都附带页码、原文、边界框和证据链接，可直接打开准确的来源区域。',
        },
        fields: {
          label: '类型化字段',
          detail: '使用发票、对账单、合同或自定义模式；缺少依据的字段会进入审核，不会被凭空生成。',
        },
        handoff: {
          label: '工作流交接',
          detail:
            '无需重新解析，即可把结果发送到 Webhook、n8n、Make、Zapier、Sheets 或人工审批节点。',
        },
      },
    },
    toolset: {
      kicker: 'AI 与自动化',
      heading: '智能体处理 PDF 所需的工具，一站备齐。',
      body: '托管应用、API 密钥、CLI、MCP 工具和自动化工作流共用同一份文档图谱，智能体不必再拼接多个 PDF 工具。',
      items: {
        parse: {
          label: '解析',
          body: '把原始 PDF 转成按页面组织的文本、表格、图片和版面节点。',
        },
        context: {
          label: '上下文',
          body: '在限定 token 内回答问题，并附上页码、原文、边界框和证据链接。',
        },
        extract: {
          label: '提取',
          body: '把 PDF 映射到应用已使用的类型化 JSON Schema 和内容契约。',
        },
        host: {
          label: '托管',
          body: '从同一文档 ID 发布带权限的 PDF 链接、预览和产物。',
        },
        review: {
          label: '审核',
          body: '为提取、无障碍、遮盖和发布决策设置持久的人工检查节点。',
        },
        convert: {
          label: '转换',
          body: '当智能体需要 HTML、图片、Markdown、CSV 或 Excel 时，调用常用 PDF 工具。',
        },
      },
    },
    developer: {
      kicker: '开发者优势',
      heading: '该开源的保持开源，需要控制的支持自托管。',
      body: 'okraPDF 以 TypeScript 为先：SDK、CLI、Schema、处理配方和本地运行时，让团队掌控自己的文档数据。',
      explore: '了解自托管',
      benefits: {
        openSource: {
          kicker: '开源',
          title: '可审查的 SDK 和 CLI',
          body: '面向智能体的 TypeScript 包采用 MIT 许可、版本化发布，并使用带下一步操作的 JSON 信封格式。',
          cta: '查看 GitHub',
        },
        selfHost: {
          kicker: '自托管',
          title: '在本地运行文档图谱',
          body: 'Docker 运行时包含 Node 22、Poppler、Tesseract、文件系统状态，以及基础解析、审计和遮盖配方。',
          cta: '查看自托管运行时',
        },
        typescript: {
          kicker: 'TypeScript',
          title: '智能体可以依赖的 Schema',
          body: 'Zod 契约、类型化 SDK 方法和内容清单，让 CLI、API 与 MCP 的解析结果保持稳定。',
          cta: '阅读文档',
        },
        community: {
          kicker: '社区',
          title: '把棘手的 PDF 带到 Discord',
          body: '在社区中排查解析边界情况、自托管配置、智能体工作流和集成方案。',
          cta: '加入 Discord',
        },
      },
    },
    industries: {
      kicker: '行业方案',
      heading: '为行业日常依赖的文档而构建。',
      body: '从团队已经处理的 PDF 开始，再把提取后的数据行送入各工作流所依赖的系统。',
      seeAll: '查看全部行业',
      cards: {
        accounting: {
          name: '会计与记账',
          tagline: '发票、收据、对账单——完整提取并分类。',
        },
        logistics: {
          name: '物流与运输',
          tagline: '提单、装箱单、采购单——提取、跟踪、按时结算。',
        },
        legal: {
          name: '法律服务',
          tagline: '合同、法院文件和遮盖版本——可搜索、可引用、更安全。',
        },
        realEstate: {
          name: '房地产与产权',
          tagline: '交割文件、保险和产权材料——结构化、索引并归档。',
        },
      },
    },
    proof: {
      points: {
        one: '一份 PDF 可转成带引用的智能体上下文、类型化 JSON、托管链接、工作流事件或审核任务。',
        two: '每个答案都保留页面证据，让智能体引用来源，而不是猜测。',
        three: '先使用托管服务；需要更高隐私时，再把确定性任务迁移到自托管运行时。',
      },
      integrations: '浏览集成指南',
    },
  },
  tools: {
    index: {
      categoriesLabel: '筛选类别',
      metaTitle: '免费 PDF 工具——编辑、转换与整理 | okraPDF',
      metaDescription:
        '免费合并、拆分、转换、压缩、OCR 和检查 PDF 无障碍。浏览器本地工具无需注册；云端工具需登录 okraPDF 账户。',
      h1: '免费 PDF 工具',
      subhead: '免费编辑、转换、整理和检查 PDF，优先在浏览器本地完成。',
      searchLabel: '搜索 PDF 工具',
      searchPlaceholder: '搜索 PDF/UA、WCAG、合并……',
      keywordPicks: '从这些工具开始',
      editorCard: {
        title: '编辑 PDF',
        body: '修改 PDF 中的文字、添加新文字、签名并整理页面。免费，在浏览器中完成。',
        cta: '打开 PDF 编辑器',
      },
    },
    categories: {
      all: '全部工具',
      organize: '整理 PDF',
      edit: '编辑 PDF',
      accessibility: '无障碍检查',
      convertTo: '转换为 PDF',
      convertFrom: '从 PDF 转换',
      optimize: '优化 PDF',
    },
    grid: {
      cloud: '云端',
      results: '找到 {{count}} 个工具',
      reset: '清除筛选',
      cloudAi: '云端 AI',
      compliance: '合规检查',
      onDevice: '本机处理',
      browserTitle: '在浏览器中运行，文件不会离开你的设备',
      openTool: '打开工具',
      useTool: '使用工具',
      noMatch: '没有找到与“{{query}}”匹配的工具。',
      popular: '热门工具',
      popularSubhead: '大家最常用的工具。',
      accessibilitySubhead: '检查 PDF/UA、Matterhorn、标签结构和需要人工复核的项目。',
      organizeSubhead: '在本机合并、拆分和重新排序页面。',
      editSubhead: '无需上传即可遮盖、签名、加水印和批注。',
      convertToSubhead: '把 Word、Excel 和图片转为 PDF。',
      convertFromSubhead: '把 PDF 导出为 Markdown、Word、Excel、JSON、HTML 等格式。',
      optimizeSubhead: '压缩、扁平化、OCR 并检查 PDF，便于分享和存储。',
      count: '{{count}} 个工具',
      count_other: '{{count}} 个工具',
    },
    detail: {
      allTools: '全部工具',
      toolAria: '{{name}}工具',
      fallbackAria: 'PDF 工具',
      cloudProcessing: '云端处理',
      cloudExtraction: '云端提取',
      browserOnly: '仅在浏览器中处理',
      howTo: '如何使用{{name}}',
      faq: '常见问题',
    },
    success: {
      next: '接下来',
      localNotice: '已在您的浏览器中处理，文件从未离开您的设备。',
      cloudNotice: '已在云端处理，任务完成后您上传的文件会被删除。',
      shareHandoff: {
        title: '以链接分享',
        body: '将 {{fileName}} 变成任何浏览器都能打开的链接。创建链接时才会上传，无需先下载再上传。',
        cta: '获取分享链接',
        note: '支持 5 MB 以内的 PDF',
        tooLarge: '这个 PDF 有 {{size}}。分享链接仅支持 5 MB 以内的 PDF。',
        compressCta: '先压缩 PDF',
        saveFirst: '压缩前，请先用上方的按钮保存这个 PDF。',
      },
      organize: {
        title: '页面已重新整理',
        body: '整理后的 PDF 已保存到您的设备。拖入另一个文件即可继续整理。',
      },
      merge: {
        title: 'PDF 已合并',
        body: '合并后的 PDF 已开始下载。在上方继续添加文件即可再合并一份。',
      },
      split: {
        title: 'PDF 已拆分',
        body: '各个页面范围已作为独立 PDF 下载。在上方选择新的范围即可再次拆分。',
      },
      compress: {
        title: 'PDF 已压缩',
        body: '压缩后的文件已开始下载。拖入另一个 PDF 即可继续压缩。',
      },
      flatten: {
        title: 'PDF 已扁平化',
        body: '表单字段与批注已并入页面内容，扁平化后的副本已开始下载。',
      },
      ocr: {
        title: '已添加文字层',
        body: '扫描件现在可以搜索和选中文字，OCR 后的副本已开始下载。',
      },
      compare: {
        title: '对比结果已就绪',
        body: '两个版本之间的差异已列在上方。载入另一组文件即可再次对比。',
      },
      metadata: {
        title: '元数据已检查',
        body: '这个 PDF 会暴露的信息——文档属性、字体与安全设置——都列在上方。',
      },
      verapdfChecker: {
        title: '预检完成',
        body: 'PDF/UA 检查结果已列在上方，每条问题都指向对应的条款。',
      },
      matterhornPdfChecker: {
        title: 'Matterhorn 检查完成',
        body: '失败条件已按检查点分组列出，其中也包含需要人工复核的项目。',
      },
      wellTaggedPdfChecker: {
        title: '标签检查完成',
        body: '这个 PDF 的标签树、阅读顺序信号与结构缺口都已汇总在上方。',
      },
      wordToPdf: {
        title: 'Word 文件已转换',
        body: 'PDF 已开始下载，原有排版保持不变。拖入另一个文档即可继续转换。',
      },
      excelToPdf: {
        title: '表格已转换',
        body: 'PDF 已开始下载。拖入另一个工作簿即可继续转换。',
      },
      jpgToPdf: {
        title: '图片已转换为 PDF',
        body: 'PDF 已按您设定的页面顺序开始下载。在上方继续添加图片即可再做一份。',
      },
      pngToPdf: {
        title: '图片已转换为 PDF',
        body: 'PDF 已按您设定的页面顺序开始下载。在上方继续添加图片即可再做一份。',
      },
      pdfToWord: {
        title: 'Word 文档已就绪',
        body: '可编辑的 .docx 已开始下载，文字、排版与表格都已保留。',
      },
      pdfToExcel: {
        title: '表格已就绪',
        body: '表格数据已作为行下载，可直接在 Excel 或 Google Sheets 中打开。',
      },
      pdfToMarkdown: {
        title: 'Markdown 已就绪',
        body: '带标题、表格和阅读顺序的 .md 文件已开始下载，内容由 ParseBench 重建。',
      },
      extract: {
        title: '表格已提取',
        body: '结构化数据已可下载。载入另一个 PDF 即可继续提取。',
      },
      pdfToJson: {
        title: 'JSON 已就绪',
        body: '文档已转换为结构化 JSON，字段与类型都符合您的设定。',
      },
      pdfToHtml: {
        title: 'HTML 页面已就绪',
        body: 'PDF 已转换为无障碍 HTML 页面，标题、表格与阅读顺序都已保留。',
      },
      handwritingOcr: {
        title: '手写内容已转录',
        body: '识别出的文字已显示在上方，可直接复制或导出。',
      },
      pdfToLink: {
        title: '分享链接已就绪',
        body: '复制上方链接即可发送这个 PDF。任何浏览器都能打开，无需安装阅读器，也无需账号。',
      },
      pdfToJpg: {
        title: '页面已导出为 JPG',
        body: '图片已按您选择的质量开始下载。载入另一个 PDF 即可导出更多页面。',
      },
      pdfToPng: {
        title: '页面已导出为 PNG',
        body: '图片已按页面原始分辨率开始下载。载入另一个 PDF 即可导出更多页面。',
      },
      watermark: {
        title: '水印已添加',
        body: '带水印的 PDF 已开始下载，水印已应用到您选择的每一页。',
      },
      pageNumbers: {
        title: '页码已添加',
        body: '带页码的 PDF 已开始下载，位置与格式与您的设置一致。',
      },
      bates: {
        title: 'Bates 编号已添加',
        body: '编号后的 PDF 已开始下载，每一页都有唯一且连续的编号。',
      },
      redact: {
        title: '涂黑内容已彻底移除',
        body: '被遮盖的内容已从文件本身删除，而不只是被挡住，涂黑后的副本已开始下载。',
      },
      highlight: {
        title: '高亮已应用',
        body: '带批注的 PDF 已开始下载，所有高亮都已保留。',
      },
      sign: {
        title: 'PDF 已签署',
        body: '签署后的 PDF 已开始下载，可以直接发送或归档。',
      },
      crop: {
        title: '页面已裁剪',
        body: '裁剪后的 PDF 已开始下载，新的页面边界已生效。',
      },
      rotate: {
        title: '页面已旋转',
        body: '校正后的 PDF 已开始下载，每一页的方向都已摆正。',
      },
    },
    uploader: {
      chooseFile: '选择文件',
      chooseFiles: '选择多个文件',
      invalidPdf: '{{name}} 不是有效的 PDF 文件。',
      unsupported: '不支持的文件类型：{{name}}',
      dropHere: '拖放到这里',
      clickOrDrop: '点击上传或拖放文件',
      multipleDescription: '添加一个或多个 PDF 文件',
      singleDescription: '上传 PDF 文档',
    },
    runners: {
      merge: {
        addTitle: '添加 PDF 或图片',
        addDescription: '支持 PDF、JPG、PNG、WebP、GIF；每张图片会成为一个 PDF 页面',
        unsupported: '不支持的文件类型：{{names}}。请使用 PDF、JPG、PNG、WebP 或 GIF。',
        addFailed: '无法添加 {{name}}：{{reason}}',
        unreadable: '文件无法读取',
        mergeFailed: '合并失败：{{reason}}',
        unexpected: '发生意外错误',
        converting: '正在转换 {{count}} 张图片',
        converting_other: '正在转换 {{count}} 张图片',
        summary: '{{files}} 个文件 · {{pages}} 页',
        clearAll: '全部清除',
        pageCount: '{{count}} 页',
        pageCount_other: '{{count}} 页',
        moveUp: '上移',
        moveDown: '下移',
        remove: '移除',
        merging: '正在合并……',
        action: '合并 {{count}} 个文件',
        needMore: '请至少再添加一个文件',
        done: '合并完成，下载已开始。',
      },
      pdfToExcel: {
        readFailed: '无法读取 PDF',
        noText: '未在此 PDF 中找到表格。',
        conversionFailed: '转换失败',
        uploadTitle: '拖入 PDF',
        uploadDescription: 'LlamaParse 读取数字版和扫描版 PDF 中的表格',
        pageSummary: '{{count}} 页',
        changeFile: '更换文件',
        extracting: '正在提取表格……',
        action: '转换并下载 .xlsx',
        done: '转换完成，下载已开始。',
        caveat: '每个表格一个工作表。',
      },
      wordToPdf: {
        docxRequired: '请上传 .docx Word 文档。旧版 .doc 文件需先另存为 .docx。',
        readFailed: '无法读取 .docx',
        conversionFailed: '转换失败',
        uploadTitle: '拖入 DOCX 文档',
        uploadDescription: '支持 .docx Word 文档',
        characterCount: '已提取 {{count}} 个字符',
        changeFile: '更换文件',
        preview: '预览',
        empty: '（空）',
        converting: '正在转换……',
        action: '转换并下载 PDF',
        done: '转换完成，下载已开始。',
      },
      pdfToJson: {
        copy: '复制',
        copied: '已复制',
        phases: {
          idle: '等待中',
          uploading: '正在上传',
          processing: '正在解析',
          ready: '已就绪',
          extracting: '正在提取',
          done: '已完成',
          error: '需要处理',
        },
        steps: {
          upload: '上传',
          parse: '解析',
          schema: '建议',
          confirm: '确认',
          extract: '提取',
        },
        presets: {
          document: {
            name: '文档',
            description: '标题、作者、章节、实体、日期、表格和关键段落。',
          },
          veryfi: {
            name: '发票',
            description: '供应商、金额、日期、付款条款和明细项。',
          },
          timesheet: {
            name: '工时表',
            description: '员工信息、每日记录、签名和薪资摘要。',
          },
          bank: {
            name: '银行对账单',
            description: '对账周期、余额和交易记录。',
          },
        },
        status: {
          uploadPdf: '上传 PDF',
          reviewSchema: '检查建议的 Schema',
          suggestingSchema: '正在建议 Schema',
          parsing: '正在使用 Gemini Flash 解析',
          jsonReady: 'JSON 已就绪',
          creatingSession: '正在创建新的文件会话',
          startingWorkflow: '正在上传并启动工作流',
          queued: '工作流已排队',
          confirmingSchema: '正在确认 Schema',
          extractingJson: '正在提取 JSON',
        },
        generatedSchema: '根据此 PDF 生成。',
        noPdf: '尚未选择 PDF',
        reset: '重置',
        replacePdf: '更换 PDF',
        uploadPdf: '上传 PDF',
        confirmSchema: '确认 Schema',
        localPreview: '文件上传时显示本地预览',
        clearFile: '清除所选文件',
        previewTitle: '已上传 PDF 的预览',
        dropPdf: '放下 PDF',
        uploadPrompt: '上传 PDF',
        uploadDescription:
          '预览会立即打开。每次上传都会使用新的文件会话，因此更换 PDF 不会受到之前单文件限制的影响。',
        choosePdf: '选择 PDF',
        fileLimit: '仅限 PDF，最大 5MB',
        suggestedSchema: '建议的 Schema',
        events: '{{count}} 个事件',
        events_other: '{{count}} 个事件',
        clear: '清除',
        agent: '智能体',
        extractionOutput: '提取结果',
        resultMatched: '结果符合当前 Schema。',
        jsonReady: 'JSON 已就绪',
        extractedFile: '已使用此 Schema 提取 {{name}}。',
        extractedGeneric: '已使用此 Schema 完成提取。',
        startFree: '免费开始',
        cost: '费用',
        duration: '用时',
        extractsLeft: '访客剩余提取次数',
        limitTitle: '已达到免费提取上限',
        limitDescription: '打开 Studio，在一个地方继续使用 PDF 工具。',
        unlimited: 'Studio',
        confirmTitle: '确认 JSON Schema',
        keepEditing: '继续编辑',
        confirmAndExtract: '确认并提取',
      },
    },
    catalog: {
      organize: { name: '整理 PDF', description: '重新排列、删除和调整页面顺序。' },
      merge: {
        name: '合并 PDF',
        description: '把多个 PDF 合并为一个文件。',
        metaTitle: '在线免费合并 PDF 文件 | okraPDF',
        metaDescription:
          '把多个 PDF 合并为一个文档。可拖动调整顺序，全程在浏览器中完成，无大小限制、无需注册。',
        h1: '合并 PDF 文件',
        subhead: '拖入多个 PDF，调整顺序，然后下载一个合并后的文件。',
        steps: [
          '把 PDF 拖入上方区域，或点击选择文件。',
          '拖动文件缩略图，按需要调整顺序。',
          '点击“合并”并下载结果；文件始终留在浏览器中。',
        ],
        faq: [
          {
            q: '在浏览器中合并 PDF 安全吗？',
            a: '安全。合并完全在浏览器中运行，文件不会上传到服务器，也不会离开你的设备。',
          },
          {
            q: '有文件大小或页数限制吗？',
            a: '没有上传限制。因为处理在本机完成，实际限制只取决于设备可用内存。',
          },
          {
            q: '合并前可以调整顺序吗？',
            a: '可以。合并前可把文件拖到任意顺序，输出 PDF 会按这个顺序排列。',
          },
          {
            q: '需要注册或付费吗？',
            a: '不需要。合并工具免费使用，无需账号、无水印，也不要求邮箱。',
          },
        ],
      },
      split: { name: '拆分 PDF', description: '按页码范围拆分 PDF。' },
      compress: { name: '压缩 PDF', description: '在尽量保持质量的同时减小文件体积。' },
      flatten: { name: '扁平化 PDF', description: '把表单字段和批注转换为静态内容。' },
      ocr: { name: 'OCR PDF', description: '为扫描版 PDF 添加可搜索文本。' },
      compare: { name: '比较 PDF', description: '并排比较两份 PDF。' },
      metadata: { name: 'PDF 元数据', description: '查看和编辑 PDF 文档属性。' },
      verapdfChecker: {
        name: 'veraPDF 检查器',
        description: '使用 veraPDF 验证 PDF/UA 和 PDF/A。',
      },
      matterhornPdfChecker: {
        name: 'Matterhorn PDF 检查器',
        description: '按 Matterhorn 协议检查 PDF/UA。',
      },
      wellTaggedPdfChecker: {
        name: 'PDF 标签检查器',
        description: '检查 PDF 是否包含屏幕阅读器所需的结构标签。',
      },
      wordToPdf: {
        name: 'Word 转 PDF',
        description: '把 Word 文档转换为 PDF。',
        metaTitle: '在线免费将 DOCX 转为 PDF | okraPDF',
        metaDescription:
          '在浏览器中把 DOCX Word 文档转换为清晰的 PDF 文本副本。免费、无需上传、无需注册、无水印。',
        h1: 'Word 转 PDF',
        subhead: '上传 .docx，直接在浏览器中获得清晰的 PDF 文本副本。',
        steps: ['上传 .docx 文件。', '我们会在本地提取文档文本并写入 PDF。', '下载生成的 PDF。'],
        faq: [
          {
            q: '会保留原有格式吗？',
            a: '浏览器版本优先保证文字可读。复杂版式、字体、表格和图片可能无法完整保留。',
          },
          {
            q: '同时支持 .doc 和 .docx 吗？',
            a: '浏览器转换器支持 .docx。请先把旧版 .doc 文件另存为 .docx，再上传。',
          },
          {
            q: '可以免费使用吗？',
            a: '可以。无需注册、无水印，而且转换在浏览器中完成，文档不会上传。',
          },
        ],
      },
      excelToPdf: { name: 'Excel 转 PDF', description: '把 Excel 表格转换为 PDF。' },
      jpgToPdf: { name: 'JPG 转 PDF', description: '把 JPG、PNG 和 WebP 图片转换为 PDF。' },
      pngToPdf: { name: 'PNG 转 PDF', description: '把 PNG 图片合并成一个 PDF。' },
      pdfToWord: { name: 'PDF 转 Word', description: '把 PDF 转换为可编辑的 Word 文档。' },
      pdfToExcel: {
        name: 'PDF 转 Excel',
        description: '把 PDF 表格提取到 Excel。',
        metaTitle: 'PDF 表格转 Excel（XLSX）| okraPDF',
        metaDescription:
          '使用 LlamaParse 把财务报告、银行对账单和发票中的 PDF 表格提取到 Excel，支持扫描版 PDF。注册 okraPDF 账号即可免费使用。',
        h1: '把 PDF 表格提取到 Excel',
        subhead: 'LlamaParse 读取 PDF（数字版或扫描版）中的表格，每个表格生成一个工作表。',
        steps: [
          '拖入包含目标表格的 PDF。',
          '登录后点击转换：PDF 会上传到私有的 okraPDF 会话，由 LlamaParse 读取每个表格。',
          '下载 .xlsx，每个表格一个工作表，可直接在 Excel 或 Google Sheets 中打开。',
        ],
        faq: [
          {
            q: '扫描版 PDF 也能处理吗？',
            a: '可以。LlamaParse 能读取扫描版和数字版 PDF；清晰的数字版 PDF 通常准确率更高。',
          },
          {
            q: '能处理银行对账单和财务报告吗？',
            a: '可以。每个表格生成一个工作表；跨页的长表格可能按页分成多个工作表。',
          },
          {
            q: '为什么需要账号？',
            a: 'LlamaParse 在云端运行，因此需要免费的 okraPDF 账号。大文件有页数上限，登录前就会提示。',
          },
          {
            q: '文件会如何处理？',
            a: '在你点击转换之前，PDF 一直保留在你的设备上；之后会上传到私有的 okraPDF 会话，由 LlamaParse 处理。',
          },
          {
            q: '能导出 CSV 或 JSON 吗？',
            a: '此工具生成 .xlsx 文件。需要结构化 JSON 请使用 PDF 转 JSON，或通过 API 编程访问。',
          },
        ],
      },
      extract: { name: 'AI 提取表格', description: '从财务 PDF 中智能提取表格。' },
      pdfToJson: {
        name: 'PDF 转 JSON',
        description: '按你的 Schema 把任意 PDF 转成结构化 JSON。',
        metaTitle: '按自定义 Schema 将 PDF 转为 JSON | okraPDF',
        metaDescription:
          '使用自定义字段名、类型和派生字段把 PDF 转为 JSON，适合 AI 智能体、RAG 管道和结构化提取。',
        h1: '按你的 Schema 将 PDF 转为 JSON',
        subhead:
          '无论发票、合同、银行对账单还是工时表，都返回严格匹配字段名、类型和计算字段的 JSON，适合向量数据库和 LLM 管道。',
      },
      pdfToMarkdown: {
        name: 'PDF 转 Markdown',
        description: '把 PDF 转为 Markdown，用于笔记、RAG 和 LLM 上下文。',
        metaTitle: '在线免费将 PDF 转为 Markdown | okraPDF',
        metaDescription:
          '使用 Gemini 驱动的 ParseBench 将 PDF 转为 Markdown，保留标题、阅读顺序、表格和扫描文字，适合 RAG、笔记和 LLM 上下文。',
        h1: '把 PDF 转为 Markdown，用于 RAG 和笔记',
        subhead:
          '拖入论文、报告、扫描件或手册。ParseBench 使用 Gemini 生成结构化 Markdown，可用于笔记应用、RAG 管道或 LLM 提示词。',
      },
      pdfToHtml: { name: 'PDF 转 HTML', description: '把 PDF 打开为可读、无障碍的网页。' },
      handwritingOcr: { name: '手写文字 OCR', description: '从手写 PDF 和图片中提取文字。' },
      pdfToLink: {
        name: 'PDF 转链接',
        description: '托管 PDF 并生成可分享链接。',
        badge: '免费账号 · 默认不公开',
      },
      pdfToJpg: { name: 'PDF 转 JPG', description: '把 PDF 页面转换为 JPG 图片。' },
      pdfToPng: { name: 'PDF 转 PNG', description: '把 PDF 页面转换为 PNG 图片。' },
      watermark: { name: 'PDF 水印', description: '给 PDF 页面添加文字水印。' },
      pageNumbers: { name: '添加页码', description: '给 PDF 添加可自定义的页码。' },
      bates: { name: '贝茨编号', description: '给法律文件添加连续的贝茨编号。' },
      redact: { name: '遮盖 PDF', description: '使用 True removal（真正移除）永久移除敏感信息；Overlay 仅在视觉上遮盖内容。' },
      highlight: { name: '高亮 PDF', description: '在 PDF 页面上添加高亮批注。' },
      sign: { name: '签署 PDF', description: '在 PDF 上添加手写签名。' },
      crop: { name: '裁剪 PDF', description: '裁剪 PDF 页边距。' },
      rotate: { name: '旋转 PDF', description: '将 PDF 页面向左或向右旋转。' },
    },
  },
} as const;
